import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  company: association(),

  email: () => faker.lorem.word(),
  provider: () => 'GOOGLE',
  roomsCount: () => 7,
});
